// extracted by mini-css-extract-plugin
export default {"societySelect":"TowerManagement_societySelect__xACFg","loading":"TowerManagement_loading__Gk6Il"};